import React from 'react'
import '../styles/upcoming.css'
import { DetailsUpcmng } from '../jsonfiles/UpComing'
import { Link } from 'react-router-dom'
import { BsBoxArrowUpRight } from 'react-icons/bs'

/* Flagship in Home Page, Events */

function UpComingEvns() {
  return (
    <div className="wrapper">
      <h2 className='mt-[40px]'>
        <strong>Our Flagship Events</strong>
      </h2>
      <div className="news">
        {DetailsUpcmng.map((article, index) => (
          <figure className="article" key={index}>
            <img src={require(`../imagProps/upcomingPosters/${article.posterPath}`)} alt={`News ${index + 1}`} loading="lazy" decoding="async" />
            <figcaption>
              <h3>{article.title}</h3>
              <p style={{ textAlign: 'justify' }}>{article.desc}</p>
              <a target={article.target} className="button-151" href={article.regLink}>Website</a>
            </figcaption>
          </figure>
        ))}
      </div>
      <div className='link'>
        <Link className='linkstyle' to="/events/events24-25">View All Events < BsBoxArrowUpRight className='icon-style' /> </Link>
      </div>
    </div>

  )
}

export default UpComingEvns